import React from "react";
import { BookmarkOutline } from "@bloomberg/media.icons";
import { Change, Variant } from "@bloomberg/media-ui-markets";
import styles from "./newsListItem.module.css";

export interface NewsListItemTicker {
  readonly symbol: string;
  readonly percentChange: number;
}

export interface NewsListItemProps {
  readonly category?: string;
  readonly headline: string;
  readonly imageUrl?: string;
  readonly tickers: readonly NewsListItemTicker[];
  readonly timestamp: string;
  readonly url?: string;
  readonly onBookmarkClick?: () => void;
  readonly showDivider?: boolean;
}

const MAX_TICKER_PILLS = 4;

export default function NewsListItem({
  category,
  headline,
  imageUrl,
  tickers,
  timestamp,
  url,
  onBookmarkClick,
  showDivider = true,
}: NewsListItemProps) {
  return (
    <>
      <div className={styles.newsListItem}>
        <a
          href={url}
          className={styles.storyLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={styles.storyRow}>
            {imageUrl ? (
              <img src={imageUrl} alt={headline} className={styles.thumbnail} />
            ) : null}

            <div className={styles.storyContent}>
              {category ? (
                <p className={styles.categoryLabel}>{category}</p>
              ) : null}
              <p className={styles.headline}>{headline}</p>
            </div>
          </div>
        </a>

        {tickers.length > 0 ? (
          <div className={styles.tickerPills}>
            {tickers.slice(0, MAX_TICKER_PILLS).map((ticker) => (
              <div key={ticker.symbol} className={styles.tickerPill}>
                <span className={styles.tickerSymbol}>{ticker.symbol}</span>
                <Change
                  percentChange={ticker.percentChange}
                  variant={Variant.refresh2024}
                  isDark
                />
              </div>
            ))}
          </div>
        ) : null}

        <div className={styles.actionBar}>
          <span className={styles.timestamp}>{timestamp}</span>
          <div className={styles.actionButtons}>
            <button
              className={styles.iconButton}
              onClick={onBookmarkClick}
              aria-label="Bookmark article"
              type="button"
            >
              <BookmarkOutline />
            </button>
          </div>
        </div>
      </div>
      {showDivider ? <div className={styles.divider} /> : null}
    </>
  );
}
